export * from './simple-tables.component';